import {useEffect, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import css from './TwitchExtensionConfiguration.module.scss';
import {
  TwitchExtensionConfiguration,
  usePulsoidClient,
} from '../../PulsoidClient';
import {ButtonV2} from '../../system/ButtonV2/ButtonV2';
import {TwitchScopeUrl} from '../../utils/TwitchScopeUrl';

type ExtensionVisibility = 'Viewers' | 'Followers' | 'Subscribers';
type TwitchExtensionVisibilityComponentProps = {
  configuration: TwitchExtensionConfiguration;
};

export const TwitchExtensionVisibilityComponent = (
  props: TwitchExtensionVisibilityComponentProps
) => {
  let [configuration, setConfiguration] = useState(props.configuration);

  return (
    <>
      <h5>Who can see Heart Rate</h5>
      <div className={css.visibility_choice_container}>
        <VisibilityChoice
          onUpdate={setConfiguration}
          visibility="Viewers"
          checked={
            !configuration.visibility.subscribers &&
            !configuration.visibility.followers
          }
        />

        <VisibilityChoice
          onUpdate={setConfiguration}
          visibility="Followers"
          checked={configuration.visibility.followers}
        />
      </div>
    </>
  );
  //<VisibilityChoice
  //      onUpdate={setConfiguration}
  //      visibility="Subscribers"
  //      checked={configuration.visibility.subscribers}
  //    />
};

type VisibilityChoiceProps = {
  visibility: ExtensionVisibility;
  checked: boolean;
  onUpdate: (value: TwitchExtensionConfiguration) => void;
};

const VisibilityChoice = (props: VisibilityChoiceProps) => {
  let client = usePulsoidClient();
  let [checkingtwitchtokenscope, setcheckingtwitchtokenscope] =
    useState<boolean>(false);

  let [
    twitchTokenWithRequiredScopeIsMissing,
    setTwitchTokenWithRequiredScopeIsMissing,
  ] = useState<boolean>(false);

  return (
    <div className={css.visibility_choice_container}>
      <label>
        <input
          type={'checkbox'}
          disabled={checkingtwitchtokenscope}
          checked={props.checked}
          onChange={async () => {
            if (props.checked && props.visibility == 'Viewers') {
              return;
            }
            setcheckingtwitchtokenscope(true);
            setTwitchTokenWithRequiredScopeIsMissing(false);
            try {
              let request = {
                subscribers:
                  props.visibility == 'Subscribers'
                    ? !props.checked
                    : undefined,
                followers:
                  props.visibility == 'Followers' ? !props.checked : undefined,
                everyone:
                  props.visibility == 'Viewers' ? !props.checked : undefined,
              };
              let result = await client.updateTwitchExtensionVisibility(
                request
              );
              if (result.ok) {
                props.onUpdate(result.value.configuration);
              } else {
                if (
                  result.error.reason == 'TwitchTokenWithRequiredScopeMissing'
                ) {
                  setTwitchTokenWithRequiredScopeIsMissing(true);
                }
              }
            } finally {
              setcheckingtwitchtokenscope(false);
            }
          }}
        />
        {checkingtwitchtokenscope && (
          <Spinner size={'sm'} animation={'border'} />
        )}
        {props.visibility}
      </label>
      {twitchTokenWithRequiredScopeIsMissing && (
        <div className={css.token_required}>
          <div>
            in order to connect followers only mode, pulsoid needs access to the
            followers by obtaining twitch token with followers access.
          </div>
          <div>
            <ButtonV2
              type="twitch"
              href={TwitchScopeUrl(
                props.visibility == 'Followers'
                  ? 'with_read_followers'
                  : 'with_read_subscriptions'
              )}
            >
              provide token
            </ButtonV2>
          </div>
        </div>
      )}
    </div>
  );
};
